export const LOCALIZATION_TABLE = {
  pagination: {
    labelDisplayedRows: "{from}-{to} de {count}",
    labelRowsPerPage: "Filas por página",
    labelRowsSelect: "Filas",
    firstAriaLabel: "Primera página",
    firstTooltip: "Primera página",
    previousAriaLabel: "Página anterior",
    previousTooltip: "Página anterior",
    nextAriaLabel: "Próxima página",
    nextTooltip: "Próxima página",
    lastAriaLabel: "Última página",
    lastTooltip: "Última página",
  },
  toolbar: {
    nRowsSelected: "{0} filas(s) seleccionadas",
    searchTooltip: "Buscar",
    searchPlaceholder: "Buscar",
  },
  header: {
    actions: "Acciones",
  },
  body: {
    emptyDataSourceMessage: "No hay información para mostrar",
    deleteTooltip: "Eliminar",
    editTooltip: "Editar",
    filterRow: {
      filterTooltip: "Filtrar",
    },
    editRow: {
      saveTooltip: "Guardar",
      cancelTooltip: "Cancelar",
      deleteText: "¿Está seguro que desea eliminar?",
    },
  },
  noData: "Sin datos",
  yes: "Si",
};
